import React from 'react';
import {ListColumnsFactoryComponent, ListConfigNamedColumn, ListProps} from '@src/@types/components/List';
import {ListView} from '@src/components/_views/configurable/ListView';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';
import OrderProductsListStatusIndicator from './OrderProductsListStatusIndicator';
import OrderProductListDeadlineAtColumn from './OrderProductListDeadlineAtColumn';
import OrderProductIndicatorsColumn from './OrderProductIndicatorsColumn';
import OrderProductsListRow from '@views/order-products/OrderProductsListRow';
import TotalPriceOfList from '@views/orders/TotalPriceOfList';

const listProps: {
    head?: ListProps<IOrderProductModel>['tableHeadProps'],
    body?: ListProps<IOrderProductModel>['tableBodyProps'],
    context?: ListProps<IOrderProductModel>['listConfigContextOptions'],
    beforeBottomPaginationNode?: ListProps<IOrderProductModel>['renderComponentBeforeTheBottomPagination'],
} = {
    head: {
        cellBeforeColumns: <td className="px-0"/>,
    },
    body: {
        cellBeforeColumnsComponent: OrderProductsListStatusIndicator,
        renderRow(properties, render) {
            return <OrderProductsListRow
                    properties={properties}
                    baseRenderer={render}
            />;
        },
    },
    context: {
        getCustomColumnComponent(config: ListConfigNamedColumn): ListColumnsFactoryComponent<IOrderProductModel> | null {
            switch (config.name) {
                case 'deadline_at':
                    return OrderProductListDeadlineAtColumn;

                case 'indicators':
                    return OrderProductIndicatorsColumn;

                default:
                    return null;
            }
        },
    },
    beforeBottomPaginationNode: TotalPriceOfList,
};

class OrderProductsList extends ListView<IOrderProductModel> {
    protected getPropsForTableHeadComponent() {
        return listProps.head;
    }

    protected getPropsForTableBodyComponent() {
        return listProps.body;
    }

    protected getListConfigContextOptions() {
        return listProps.context;
    }

    protected getComponentToRenderBeforeTheBottomPagination() {
        return listProps.beforeBottomPaginationNode;
    }
}

export default OrderProductsList.getStoreConnector()(OrderProductsList);
